var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useEntity } from '../hooks/use-entity';
import { DottedLine } from '../elements/dotted-line';
import { EntityAsideHeaderDefaultProps } from './entity-aside-header';
import { EntityMainHeader, EntityMainHeaderDefaultProps } from './entity-main-header';
import { EntityGridDetailsAsideHeader } from '../explorer/explorer-aside-header';
var cls = classNames('entity-grid-details-layout');
export var EntityGridDetailsLayoutDefaultProps = {
  asideHeaderProps: EntityAsideHeaderDefaultProps,
  mainHeaderProps: EntityMainHeaderDefaultProps,
  split: [4.5, 5.5],
  asideMaxWidth: 600,
  chromeWidth: 0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    flex: 1 0 0;  \n  "], ["\n    display: flex;\n    align-items: flex-start;\n    flex: 1 0 0;  \n  "])))
});
var AsideStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-shrink: 0;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;    \n    background-color: ", ";\n    position: fixed;\n    transition: left 0.3s;\n    height: 100vh;\n    z-index: 500;\n    ", "\n\n\n    ", "\n\n  "], ["\n    display: flex;\n    flex-shrink: 0;\n    flex-direction: column;\n    align-items: flex-start;\n    align-self: stretch;    \n    background-color: ", ";\n    position: fixed;\n    transition: left 0.3s;\n    height: 100vh;\n    z-index: 500;\n    ", "\n\n\n    ", "\n\n  "])), theme.COLOR('bright-warm'), function (_a) {
    var _isRevealed = _a._isRevealed,
      _chromeWidth = _a._chromeWidth;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      left: ", ";\n      width: calc(100% - ", "px);\n      top: 0;\n    "], ["\n      left: ", ";\n      width: calc(100% - ", "px);\n      top: 0;\n    "])), _isRevealed ? 0 : '200vw', _chromeWidth);
  }, function (_a) {
    var _percentageWidth = _a._percentageWidth;
    return _percentageWidth && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-basis: ", "%;\n    "], ["\n      flex-basis: ", "%;\n    "])), _percentageWidth);
  }),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    z-index: default;\n    position: static;\n    height: auto;\n\n    \n    ", "\n    display: flex;\n  "], ["\n    z-index: default;\n    position: static;\n    height: auto;\n\n    \n    ", "\n    display: flex;\n  "])), function (_a) {
    var _maxWidth = _a._maxWidth;
    return _maxWidth && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), _maxWidth);
  })
});
var MainHeaderStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var AsideHeaderStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MainStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    gap: ", ";\n  "], ["\n    gap: ", ";\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    overflow: auto;\n    flex-grow: 1;\n    height: calc(100vh - 120px);\n    gap: ", ";\n  "], ["\n    overflow: auto;\n    flex-grow: 1;\n    height: calc(100vh - 120px);\n    gap: ", ";\n  "])), theme.UNIT(5))
});
var HeaderContainerStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    padding: 0 ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    padding: 0 ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4)),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.UNIT(6))
});
var LineStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  desktop: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Aside: styled.aside(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  AsideHeader: styled(EntityGridDetailsAsideHeader).attrs(cls.attr('aside-header'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), AsideHeaderStyles),
  Main: styled.main(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Line: styled(DottedLine)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  HeaderContainer: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), HeaderContainerStyles),
  MainHeader: styled(EntityMainHeader).attrs(cls.attr('main-header'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), MainHeaderStyles)
};
export var EntityGridDetailsLayout = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    aside = props.aside,
    main = props.main,
    chromeWidth = props.chromeWidth,
    asideHeaderProps = props.asideHeaderProps,
    mainHeaderProps = props.mainHeaderProps,
    asideMaxWidth = props.asideMaxWidth,
    asideIsRevealed = props.asideIsRevealed;
  var entity = useEntity(props.entity);
  var _b = __read(((_a = props.split) === null || _a === void 0 ? void 0 : _a.length) === 2 ? props.split : [4, 6], 2),
    asideWidth = _b[0],
    mainWidth = _b[1];
  var asidePercentageWidth = asideWidth / (asideWidth + mainWidth) * 100;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Aside, {
    _chromeWidth: chromeWidth,
    _isRevealed: asideIsRevealed,
    _percentageWidth: asidePercentageWidth,
    _maxWidth: asideMaxWidth
  }, React.createElement(My.AsideHeader, {
    navigationProps: asideHeaderProps,
    entity: entity
  }), aside), React.createElement(My.Main, null, React.createElement(My.HeaderContainer, null, React.createElement(My.Line, {
    color: "line-mid",
    height: 2
  }), React.createElement(My.MainHeader, __assign({}, mainHeaderProps, {
    entity: entity
  }))), main || children));
};
EntityGridDetailsLayout.defaultProps = EntityGridDetailsLayoutDefaultProps;
EntityGridDetailsLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;